import LedgerTableContainer from './LedgerTable.container';

export default LedgerTableContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/LedgerTable/index.js